<template>
  <div>
    <purchaserTable ref="purchaserVisitListTable" ></purchaserTable>
  </div>
</template>

<script>
    import purchaserTable from './purchaserTable'
    export default {
        components: {
            purchaserTable
        },
        data() {
          return {
            hello:"123" 
          }
           
        },

        methods: {
            addVisitList(){
                
            }
        }
    }
</script>

<style lang="less" scoped>
    .search-wrapper {
        margin: 0 0 10px;
        display:inline-block;
    }
</style>